<template>
  <div class="koc-block koc-payment-create-block">
    <main class="koc-content-main expanded">
      <form id="chargify-form">
        <div class="koc-wrapper">
          <div class="koc-full">
            <div class="koc-half">
              <span class="float-left koc-flex-center koc-heavy-text">
                Pay with a CreditCard
                <span class="koc-card-images">
                  <img src="@/assets/images/cards.png">
                </span>
              </span>
              <div
                v-if="state.payment_type === 'authorizenet'"
                class="koc-full koc-authorizenet"
              >
                <div class="koc-cardfront">
                  <div id="chargify-card-number" />
                </div>

                <div class="koc-cardback">
                  <div
                    id="chargify-exp-month"
                    class="koc-one-third"
                  />
                  <div
                    id="chargify-exp-year"
                    class="koc-one-third"
                  />
                  <div
                    id="chargify-card-cvv"
                    class="koc-one-third"
                  />
                </div>
              </div>
              <div
                v-if="state.payment_type === 'braintree_blue'"
                class="koc-full koc-braintree"
              >
                <div class="koc-image">
                  <img src="@/assets/images/paypal.png">
                </div>
                <h5 class="koc-details">
                  {{ state.first_name }} {{ state.last_name }}
                  <br>
                  {{ state.email }}
                </h5>
              </div>

              <div
                v-if="state.payment_type === 'authorizenet'"
                class="koc-full"
              >
                <div class="koc-flex-center">
                  <span class="koc-heavy-text">Or Pay With</span>
                  <div id="paypal-button" />
                </div>
              </div>
            </div>

            <div class=" koc-half">
              <div class="koc-full address_name">
                <div class="forty">
                  <form-input-component
                    :key="state.stateKey"
                    :value="state.first_name"
                    autocomplete="given-name"
                    label="First Name"
                    name="first_name"
                    type="text"
                    @update="state.update"
                  />
                </div>
                <div class="sixty">
                  <form-input-component
                    :key="state.stateKey"
                    :value="state.last_name"
                    autocomplete="family-name"
                    label="Last Name"
                    name="last_name"
                    type="text"
                    @update="state.update"
                  />
                </div>
              </div>

              <div class="address1 koc-full">
                <div class="koc-full">
                  <form-input-component
                    :key="state.stateKey"
                    :value="state.billing_address"
                    autocomplete="address-line1"
                    label="Billing Address"
                    name="billing_address"
                    type="text"
                    @update="state.update"
                  />
                </div>
              </div>

              <div class="address2 koc-full">
                <div class="koc-full">
                  <form-input-component
                    :key="state.stateKey"
                    :value="state.billing_address_2"
                    autocomplete="address-line2"
                    label="Billing Address (cont.)"
                    name="billing_address_2"
                    type="text"
                    @update="state.update"
                  />
                </div>
              </div>

              <div class="address3 koc-full">
                <div class="forty">
                  <form-input-component
                    :key="state.stateKey"
                    :value="state.billing_city"
                    autocomplete="address-level2"
                    label="City"
                    name="billing_city"
                    type="text"
                    @update="state.update"
                  />
                </div>
                <div class="sixty">
                  <form-select-state-country-component
                    :key="state.stateKey"
                    :options="state.states"
                    :placeholder="state.billing_country ? 'State or Region' : 'Select Country'"
                    :value="state.billing_state"
                    label="State"
                    @selected="regionSelect"
                  />
                </div>
              </div>

              <div class="address4 koc-full">
                <div class="forty">
                  <form-input-component
                    :key="state.stateKey"
                    :value="state.billing_zip"
                    autocomplete="postal-code"
                    label="Postal Code"
                    name="billing_zip"
                    type="text"
                    @update="state.update"
                  />
                </div>
                <div class="sixty">
                  <form-select-state-country-component
                    :key="state.stateKey"
                    :options="state.countries"
                    :value="state.billing_country"
                    label="Country"
                    placeholder="Country"
                    @selected="countrySelect"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div class="koc-wrapper">
        <div
          v-if="canCreate"
          class="koc-full"
        >
          <div class="float-right">
            <button
              :disabled="!state.canSubmit"
              class="koc-button koc-ripple"
              @click="submit"
            >
              Save Billing Details
            </button>
          </div>
        </div>
        <div
          :class="{ hidden: !canCreate }"
          class="koc-full"
        >
          <p
            v-if="missingFields()"
            class="koc-warning koc-row float-right"
          >
            {{ missingFields() }}
          </p>
        </div>
      </div>
      <div
        v-if="state.showNotification"
        class="koc-notification koc-full"
      >
        <h3>{{ state.notification }}</h3>
        <div
          class="koc-close"
          @click="clearNotification"
        />
      </div>
    </main>
  </div>
</template>

<script src="./create.js"></script>
<style lang="scss" scoped src="./create.scss"></style>
<style lang="scss" src="./chargify.scss"></style>
